import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { EncryptStorage, LanguageVoData } from "../..";
import { StorageData } from "../../storage/storage-data";
var LanguageModel = /** @class */ (function () {
    function LanguageModel(events, storage) {
        this.events = events;
        this.storage = storage;
        this._model = new LanguageVoData();
    }
    LanguageModel.prototype.load = function () {
        var _this = this;
        this.storage.load("languages", false).then(function (res) {
            if (res != null && typeof res != 'string') {
                _this._model = res;
                _this.events.publish(LanguagesEvent.LOADED);
            }
        });
    };
    LanguageModel.prototype.save = function (storageData) {
        storageData.key = "languages";
        storageData.item = this._model;
        storageData.encrypt = false;
        return this.storage.saveAs(storageData);
    };
    Object.defineProperty(LanguageModel.prototype, "languages", {
        get: function () {
            return Array.from(this._model.languages);
        },
        enumerable: true,
        configurable: true
    });
    LanguageModel.prototype.setLanguages = function (values, preventDefault) {
        this._model.languages = values;
        return this.save(new StorageData(LanguagesEvent.LANGUAGES_CHANGED, preventDefault, values));
    };
    Object.defineProperty(LanguageModel.prototype, "language", {
        get: function () {
            return this._model.language;
        },
        enumerable: true,
        configurable: true
    });
    LanguageModel.prototype.setLanguage = function (value, preventDefault) {
        this._model.language = value;
        return this.save(new StorageData(LanguagesEvent.LANGUAGE_CHANGED, preventDefault, value));
    };
    Object.defineProperty(LanguageModel.prototype, "defaultLanguage", {
        get: function () {
            return this._model.defaultLanguage;
        },
        enumerable: true,
        configurable: true
    });
    LanguageModel.prototype.setDefaultLanguage = function (value, preventDefault) {
        this._model.defaultLanguage = value;
        return this.save(new StorageData(LanguagesEvent.DEFAULT_LANGUAGE_CHANGED, preventDefault, value));
    };
    LanguageModel.prototype.clear = function (preventDefault, preventSave) {
        this._model.languages = [];
        this._model.language = null;
        var storageData = new StorageData(LanguagesEvent.CLEARED, preventDefault);
        storageData.preventSave = preventSave;
        return this.save(storageData);
    };
    LanguageModel.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LanguageModel.ctorParameters = function () { return [
        { type: Events, },
        { type: EncryptStorage, },
    ]; };
    return LanguageModel;
}());
export { LanguageModel };
export var LanguagesEvent;
(function (LanguagesEvent) {
    LanguagesEvent["LOADED"] = "language:loaded";
    LanguagesEvent["LANGUAGE_CHANGED"] = "language:changed";
    LanguagesEvent["DEFAULT_LANGUAGE_CHANGED"] = "default-language:changed";
    LanguagesEvent["LANGUAGES_CHANGED"] = "languages:changed";
    LanguagesEvent["CLEARED"] = "languages:cleared";
})(LanguagesEvent || (LanguagesEvent = {}));
//# sourceMappingURL=language-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/language/language-model.js
// module id = 363
// module chunks = 14